<template>
  <div class="shimmer rounded-lg absolute">
    <div
      :class="[
        $store.state.theme.isDarkMode ? 'shimmer-line-dark' : 'shimmer-line',
      ]"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    mode: {},
  },
};
</script>

<style scoped>
.shimmer {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.shimmer-line-dark {
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent 25%,
    #494949 60%,
    transparent 75%
  );
  background-size: 200% 100%;
  animation: shimmer 3s infinite linear;
}

.shimmer-line {
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent 25%,
    #e9e9e9 60%,
    transparent 75%
  );
  background-size: 200% 100%;
  animation: shimmer 3s infinite linear;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
